import React from 'react';
import Dashboard from './Dashboard';

interface HomeScreenProps {
  onLogout: () => void;
}

const HomeScreen: React.FC<HomeScreenProps> = ({ onLogout }) => {
  return <Dashboard onLogout={onLogout} />;
};

export default HomeScreen;